import * as React from "react"
import {Box, Stack, Typography} from "@mui/material";

import {IconSeeker} from "@components/ui";


export default function AppWrapperPageNoData({ title, description, sx={}, ...props }) {

    return <Stack alignItems="center" justifyContent="center" sx={{ textAlign: 'center', py: 8, px: 4, ...sx }} {...props}>

		<Box sx={{
			width: 80,
			height: 80,
			borderRadius: '50%',
			backgroundColor: '#F3F4F6',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			mb: 3,
		}}>
			<IconSeeker icon="inbox" sx={{ fontSize: 36, color: '#9CA3AF' }} />
		</Box>

		<Typography sx={{ fontSize: 18, fontWeight: 600, color: '#6B7280', mb: 0.5 }}>
			{title || 'No Data'}
		</Typography>

		{description && <Typography sx={{ fontSize: 14, color: '#9CA3AF', maxWidth: 360 }}>
			{description}
		</Typography> }
    </Stack>
}